import { render, staticRenderFns } from "./ResponsesFromRecipients.vue?vue&type=template&id=97f53a64&scoped=true&"
import script from "./ResponsesFromRecipients.vue?vue&type=script&lang=js&"
export * from "./ResponsesFromRecipients.vue?vue&type=script&lang=js&"
import style0 from "./ResponsesFromRecipients.vue?vue&type=style&index=0&id=97f53a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f53a64",
  null
  
)

export default component.exports